export interface ICompanySaveRequest {
    OrganizationName: string;
    IndividualId: string;
    CrNumber: string;
    Town: string;
    StreetNo: string;
    Building: string;
    Block: string;
    FlatNumber: string;
    PoBox: string;
}

export const CompanySaveRequest :ICompanySaveRequest = {
    OrganizationName : "",
    IndividualId : "",
    CrNumber : "",
    Town : "",
    StreetNo : "",
    Building : "",
    Block : "",
    FlatNumber : "",
    PoBox : "",
}